import {Injectable, OnDestroy} from '@angular/core';
import {BehaviorSubject, Observable, ReplaySubject} from 'rxjs';
import {SortTableRow, SortTableUniqueRowId} from '../../shared/models/sort-table/types';

@Injectable()
export class SortTableInstanceService implements OnDestroy {
  /**
   * Whether checkboxes appear in place of kebabs on table rows.
   */
  get bulkSelectActive$(): Observable<boolean> {
    return this._bulkSelectActive$.asObservable();
  }


  readonly _bulkSelectActive$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  /**
   * Emits the latest set (as an array) of selected rows IDs anytime there is a change.
   */
  readonly bulkSelectedRowsIds$: ReplaySubject<SortTableUniqueRowId[]> = new ReplaySubject<SortTableUniqueRowId[]>(1);

  /**
   * Holds a set of unique row IDs.
   *
   * @private
   */
  private bulkSelectedRowsSet: Set<SortTableUniqueRowId> = new Set<SortTableUniqueRowId>();


  ngOnDestroy() {
    this._bulkSelectActive$.complete();
    this.bulkSelectedRowsIds$.complete();
  }


  activateBulkSelect() {
    this._bulkSelectActive$.next(true);
  }


  deactivateBulkSelect() {
    this._bulkSelectActive$.next(false);
    this.bulkSelectedRowsIds$.next([]);
    this.bulkSelectedRowsSet.clear();
  }

  /**
   * Adds to the set of unique context IDs
   *
   * @param row
   * @return {boolean} - Whether adding to the set succeeded
   */
  selectRow(row: SortTableRow): boolean {
    const rowId = row.context as SortTableUniqueRowId;

    this.bulkSelectedRowsSet.add(rowId);
    this.bulkSelectedRowsIds$.next([...this.bulkSelectedRowsSet]);

    return true;
  }

  /**
   * Deletes from the set of unique context IDs
   *
   * @param row
   */
  deselectRow(row: SortTableRow) {
    const rowId = row.context as SortTableUniqueRowId;
    this.bulkSelectedRowsSet.delete(rowId);
    this.bulkSelectedRowsIds$.next([...this.bulkSelectedRowsSet]);
  }


  isRowSelected(row: SortTableRow): boolean {
    const rowId = row.context as SortTableUniqueRowId;
    return this.bulkSelectedRowsSet.has(rowId);
  }
}
